import { useEffect, useRef } from 'react';
import { useCheckoutState } from '../../utils/checkoutState';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    _itt?: { c: string; s: string; t: string };
  }
}

const AFTERPAY_CLIENT_ID = '71597';

const AfterpayPayment = () => {
  const { checkoutState } = useCheckoutState();
  const token = checkoutState.orderState.payment?.selected?.[0].configuration?.initializationData?.deviceIdent?.token;
  const previousToken = useRef();

  useEffect(() => {
    if (!token || token === previousToken.current) {
      return;
    }

    previousToken.current = token;

    window._itt = { c: AFTERPAY_CLIENT_ID, s: token, t: 'CO' };

    const script = document.createElement('script');
    script.id = 'device-fingerprint-script';
    script.async = true;
    script.src = `https://uc8.tv/${AFTERPAY_CLIENT_ID}.js`;
    document.head.appendChild(script);
    // eslint-disable-next-line consistent-return
    return () => {
      document.head.removeChild(script);
      delete window._itt;
    };
  }, [token, previousToken]);

  return null;
};

export default AfterpayPayment;
